import React, {Suspense} from 'react';

import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import store from '@/store';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorComponent from '@/common/error-boundary-fallback';
import { boundaryErrorHandler } from '@/common/telemetry';
//import DefaultSkeleton from '@/common/skeleton/default-skeleton';

const handlePanelError = boundaryErrorHandler('panel-lazy-loader');

const PanelLazyLoader = ({component: Component, ...restProps}) => {
  const navigate = useNavigate();
  
  const userDetails = store.getState().userDetails;

  return (
    <Suspense fallback={<Spin percent='auto' fullscreen />}>
      <ErrorBoundary FallbackComponent={ErrorComponent}
          onError={handlePanelError}
          onReset={() => navigate('/')}
      >
          <Component permissions={userDetails.permissions} {...restProps} />
      </ErrorBoundary>
    </Suspense>
  );
}
export default PanelLazyLoader